(function() {
  var initPaySub = function() {
    var elRoot = document.querySelector('#paysub');
    if (!elRoot) return;
    setTimeout(() => {
      elRoot.style.display = '';
    }, 1000);
    setTimeout(() => {
      onWaitReady();
    }, 3000);

    var elForm = elRoot.querySelector('form');
    var elSubForm = elForm.querySelector('.sub-form');
    var elFormError = elForm.querySelector('.form-error');
    var elReCaptchaCheckboxCon = elForm.querySelector('.recaptcha-checkbox-con');
    var waitReady = false;
    var recaptchaReady = false;

    var action = '/subscribe/' + (/[^w]draft=/i.test(window.location.search) ? '?draft=true' : '');

    function onWaitReady(){
      waitReady = true;
      if (recaptchaReady) {
        open();
      }
    }
    function onReCaptchaReady(){
      recaptchaReady = true;
      if (waitReady) {
        setTimeout(() => {
          open();
        }, 500);
      }
    }
    function open() {
      if (document.body.classList.contains('open-pw')) return;
      document.body.classList.add('open-pw');
    }
    function close() {
      document.body.classList.remove('open-pw');
    }
    elRoot.querySelector('.close').addEventListener('click', function(){
      close();
    });

     function getUrlParam(name, url){
        url = url ? url : window.location.href;
        var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (results == null){
          return null;
        }
        else {
          return decodeURI(results[1]) || 0;
        }
    }

    var setLoading = function(isLaoding) {
      if (isLaoding) {
        elSubForm.classList.add('loading');
      } else {
        elSubForm.classList.remove('loading');
      }
      [].slice.call(elForm.elements).map(function(el) {
        if (~['input', 'select', 'textarea', 'button'].indexOf(el.tagName.toLowerCase())) {
          if (isLaoding) {
            el.disabled = true;
          } else {
            el.disabled = false;
          }
        }
      })
    }

    var setError = function(msg) {
      if (msg) {
        elSubForm.classList.add('has-error');
        elFormError.classList.add('has-error');
        elFormError.innerText = msg;
      } else {
        elSubForm.classList.remove('has-error');
        elFormError.classList.remove('has-error');
        elFormError.innerText = '';
      }
    }

    var setSuccess = function(data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'subscribe', form_type: 'sub_subscribe_success' });
      try {
        const encodedId = document.cookie.split('; ').find(row => row.startsWith('encoded_id=')).split('=')[1];
        if (encodedId) {
          if (!window.dataLayer.some(obj => obj.user_id && obj.user_id === encodedId)) {
            window.dataLayer.push({ user_id: encodedId });
          }
        }
      } catch(err) {
        console.error(err);
      }
      var redirectUrl = '/subscribe/all_set/' + (/[^w]draft=/i.test(window.location.search) ? '?draft=true' : '');
      var pageUrl = new URL(window.location.href);
      if (pageUrl.searchParams.has('utm_campaign')) {
        if (redirectUrl.indexOf('?') === -1) {
          redirectUrl += '?';
        } else {
          redirectUrl += '&';
        }
        redirectUrl += 'campaign_config=' + encodeURIComponent(pageUrl.searchParams.get('utm_campaign'));
      }
      window.setTimeout( function(){
        window.open(redirectUrl, '_blank');
        close();
      }, 100 );
    }

    var setNeedVerify = function(data) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'subscribe_need_verify', ...data });
      var redirectUrl = '/subscribe/almost_done/' + (/[^w]draft=/i.test(window.location.search) ? '?draft=true' : '');
      window.setTimeout( function(){
        window.open(redirectUrl, '_blank');
        close();
      }, 100 );
    }

    reCaptchaClient.renderCheckbox(elReCaptchaCheckboxCon, onReCaptchaReady);

    elForm.addEventListener('submit', function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      setError();
      var email = elForm.elements.subscribe_email ? elForm.elements.subscribe_email.value : '';
      var list = elForm.elements.subscribe_list ? elForm.elements.subscribe_list.value : '';
      var utm_campaign = getUrlParam( 'utm_campaign' );
      var utm_medium = getUrlParam( 'utm_medium' );
      var utm_content = getUrlParam( 'utm_content' );
      var utm_source = getUrlParam( 'utm_source' );
      var utm_term = getUrlParam( 'utm_term' );

      if (email && list) {
        var sendJson = {
          subscribe_email: email,
          subscribe_list: list,
          utm_campaign: utm_campaign,
          utm_medium: utm_medium,
          utm_content: utm_content,
          utm_source: utm_source,
          utm_term: utm_term,
        };

        var xhr = new XMLHttpRequest();
        xhr.open('POST', action, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.onload = function() {
          setLoading();
          if (xhr.status === 200) {
            try {
              var jsonResult = JSON.parse(xhr.responseText);
              if (jsonResult.status === 'success') {
                setSuccess(jsonResult);
              } else {
                if (jsonResult.error) {
                  if( 'reCaptchaV3Failed' === jsonResult.error ){
                    reCaptchaClient.renderCheckbox(elReCaptchaCheckboxCon);
                  }else if( 'need_verify' === jsonResult.error ){
                    setNeedVerify(sendJson);
                  }else{
                    setError(jsonResult.error);
                  }
                } else {
                  setError('Unknow Error, Please try again or contact us if you keep running into this error.');
                }
              }
            } catch (e) {
              setError('Result Error, Please try again or contact us if you keep running into this error.');
            }
          } else {
            setError('Server Error, Please try again or contact us if you keep running into this error.');
          }
        };

        xhr.onerror = function(e) {
          setLoading();
          setError('Network Error, Please check your network and try again.');
        };

        setLoading(true);
        reCaptchaClient.verify(elReCaptchaCheckboxCon, 'subscribe_sub', function(err,appendToken){
          if( !err ){
            sendJson = appendToken(sendJson);
            xhr.send(JSON.stringify(sendJson));
          }else{
            setError('Please complete the captcha to proceed.');
            setLoading();
          }
        } );
      } else if (!email) {
        setError('Email is required.');
      } else if (!list) {
        setError('List is required.');
      }
    })
  }

  document.addEventListener('DOMContentLoaded', initPaySub);
})();